async function serverPostData(path, formdata, status = 0) {

    
  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;

  const serverPath = protocol + "://" + ip + ":" + port + path;

    
    console.log('Sending data to server at: ' + serverPath);

    try {
      const response = await fetch(serverPath, {
        method: 'POST',
        body: formdata,
      });
      console.log('Data: ' + response);
      
      const responseData = await response.json();
      responseData.status = response.status;
      
      if (response.ok || response.status === 401) {
        console.log('Data sent successfully' + response.status);
      } else {
        console.error('Failed to send data');
      }
      return responseData;
    } catch (error) {
      console.error('Error:', error);
      alert('Error:\n' + error);
      return error;
    }
  }
  
  export default serverPostData;
  // Example usage:
  //const dataToSend = 'Hello from React!';
  //sendDataToFlask(dataToSend);